export const TEACHER_CONTROLS_TO_HIDE_TOOL_BAR = ['Construction Tools'];
export const TILES_TO_HIDE = [
  'non-trans-dice',
  'polyominoes',
  'number-dots',
  'number-grid',
  'polyhedral-dice',
  'playing-cards',
  'pentagons',
  'dominoes',
];
export const RETRY_TIME = 5000;
export const AWS_TIMER = 30 * 60 * 1000;
export const MATHIGON_ACTIVITY_QUERY = { type: 'wb_activity' };
